import { Action } from 'redux';

import { SelectSortOrder } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { IOrderClause } from '../../ts/ServerApi/types/IOrderClause';

export interface SelectSortOrderAction extends Action {
  readonly order: ReadonlyArray<IOrderClause>;
}

export function selectSortOrder(order: ReadonlyArray<IOrderClause>): SelectSortOrderAction {
  return {
    type: SelectSortOrder,
    order
  };
}

export const isSelectSortOrderAction = isActionFactory<SelectSortOrderAction>(SelectSortOrder);
